import React from 'react';

type AppShellProps = {
  children: React.ReactNode;
};

/**
 * Root layout: full viewport, no device frame. Content is capped on large screens for readability.
 */
export const AppShell: React.FC<AppShellProps> = ({ children }) => {
  return (
    <div className="flex h-svh min-h-svh w-full flex-col overflow-hidden bg-background">
      <div className="mx-auto flex h-full min-h-0 w-full max-w-7xl flex-1 flex-col overflow-y-auto px-0 sm:px-4 lg:px-8">
        {children}
      </div>
    </div>
  );
};
